import { combineReducers } from '@reduxjs/toolkit';
import { reducer as userReducer } from 'src/slices/user';
import { reducer as workspaceReducer } from 'src/slices/workspace';
import { reducer as workspaceAssetTypeReducer } from 'src/slices/workspaceAssetType';
import { reducer as locationReducer } from 'src/slices/workspaceLocation';
import { reducer as memberReducer } from 'src/slices/workspaceMember';
import { reducer as workspaceUserReducer } from 'src/slices/workspaceUser';

const rootReducer = combineReducers({
  location: locationReducer,
  member: memberReducer,
  workspace: workspaceReducer,
  workspaceUser: workspaceUserReducer,
  workspaceAssetType: workspaceAssetTypeReducer,
  user: userReducer
});

export default rootReducer;
